var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#CCC",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.174 6.368l3.86 3.834 3.806-3.754a1.288 1.288 0 011.803 0c.494.49.494 1.3 0 1.79l-3.793 3.769 3.793 3.768c.494.49.494 1.3 0 1.79-.495.491-1.31.491-1.803 0l-3.793-3.767-3.86 3.834c-.494.49-1.309.49-1.803 0a1.267 1.267 0 010-1.791l3.86-3.834L6.37 8.159a1.267 1.267 0 010-1.79 1.288 1.288 0 011.803 0z"
  })));
}
export default SvgCross;